import apiClient from "./apiClient";


export const getAllClientClaims = async () => {

    const response = await apiClient.get(
        "/client-claims/all"
    );

    return response.data;

};


export const getClientClaimById = async (id) => {

    const response = await apiClient.get(
        `/client-claims/${id}`
    );

    return response.data;

};


export const createClientClaim = async (data) => {

    const response = await apiClient.post(
        "/client-claims/create",
        data
    );

    return response.data;

};


export const updateClientClaim = async (id, data) => {

    const response = await apiClient.put(
        `/client-claims/${id}`,
        data
    );

    return response.data;

};


export const deleteClientClaim = async (id) => {

    const response = await apiClient.delete(
        `/client-claims/${id}`
    );

    return response.data;

};